"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IDENTITY_NOT_NULL = exports.IDENTITY_TRUE = exports.IDENTITY = void 0;

const IDENTITY = item => item;

exports.IDENTITY = IDENTITY;

const IDENTITY_TRUE = () => true;

exports.IDENTITY_TRUE = IDENTITY_TRUE;

const IDENTITY_NOT_NULL = item => item != null && item != undefined;

exports.IDENTITY_NOT_NULL = IDENTITY_NOT_NULL;